import { DSFormFieldDescription } from 'shared-definitions/types'
import { ApiFormFieldProps } from 'data-source/types.wp'

export function formFieldsMapper(input: ApiFormFieldProps): DSFormFieldDescription {
  return {
    value: null,
    name: input.name,
    type: input.type,
    placeholder: input.placeholder,
    required: input.required,
  }
}
